import { render } from "./CheckboxItem.vue?vue&type=template&id=b1100d8c&scoped=true"
import script from "./CheckboxItem.vue?vue&type=script&lang=js"
export * from "./CheckboxItem.vue?vue&type=script&lang=js"

import "./CheckboxItem.vue?vue&type=style&index=0&id=b1100d8c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1100d8c"]])

export default __exports__